import React, { useState } from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { useDispatch } from "react-redux";
import { Typography, Space, Button, Form, Checkbox } from "antd";
import FormSetup from "../../../../components/Forms/FormSetup";
import { postData } from "../../../../actions/developer";
const { Text } = Typography;

const InProbation = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState(null);
  console.log(selectedUserData, "selectedUserData")
  const [selectedRecipients, setSelectedRecipients] = useState({
    sendToReportingManager: false,
    sendToEmployee: false,
    sendToHR: false,
    sendToBuisinessUnit: false,
  });
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setSelectedRecipients((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };
  

  const handleStartEvaluation = (userId: string, user: any) => {
    setSelectedUserId(userId);
    setSelectedUserData(user);
    setOpen(true);
  };
  
  const handleSubmitEvaluation = async () => {
    if (!selectedUserId || !selectedUserData) {
      console.warn("Invalid user data");
      return;
    }
    const selectedRecipientIds = [];
  
    if (selectedRecipients.sendToReportingManager && selectedUserData?.reportingManager?._id) {
      selectedRecipientIds.push(selectedUserData.reportingManager._id);
    }
    if (selectedRecipients.sendToEmployee && selectedUserData?._id) {
      selectedRecipientIds.push(selectedUserData._id);
    }
    if (selectedRecipients.sendToHR && selectedUserData?.hr?._id) {
      selectedRecipientIds.push(selectedUserData.hr._id);
    }
    // // Use the same key as defined in your form: "sendToBuisinessUnit"
    // if (selectedRecipients.sendToBuisinessUnit && selectedUserData?.businessUnit?.head?._id) {
    //   selectedRecipientIds.push(selectedUserData.businessUnit.head._id);
    // }
  
    if (selectedRecipientIds.length === 0) {
      console.warn("No recipients selected.");
      return;
    }

    console.log("Selected Recipients:", selectedRecipients);
  console.log("Selected User Data:", selectedUserData);
  console.log("Final Selected Recipient IDs:", selectedRecipientIds);
  
    setLoading(true);
    try {
      const response = await dispatch(
        postData("/inProbation/evaluation/start", { userId: selectedUserId })
      );
  
      if (response.code === 0) {
        console.log("Something went wrong");
        return;
      }
  
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== selectedUserId));
      setOpen(false);
  
      await dispatch(
        postData("/inProbation/sendEmail", {
          receiver: selectedRecipientIds, // Sending an array of recipient IDs
        })
      );
  
    } catch (error) {
      console.error("Error starting evaluation:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };
  
  
  
  const formatDate = (date: string | Date) => {
    const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  const getDaysRemaining = (date: string) => {
    const endDate = date ? new Date(date) : null;
    if (!endDate || isNaN(endDate.getTime())) {
      return "Invalid date";
    }
    const days = Math.ceil((endDate.getTime() - new Date().getTime()) / (1000 * 3600 * 24));
    return days > 0 ? `${days} days remaining` : "Ended";
  };

  const config: MasterConfigs = {
    api: () => "/inProbation",
    modalTitle: () => "Start Evaluation",
    getFormColumns: () => [
      {
        type: "checkbox",
        label: (
          <Text>
            Send Evaluation form to Reporting Manager{" "}
            <Text strong>{selectedUserData?.reportingManager.firstName}</Text>
          </Text>
        ),
        name: "sendToReportingManager",
        span: 24,
        onChange: handleCheckboxChange,
      },
      {
        type: "checkbox",
        label: (
          <Text>
            Send Evaluation form to Employee{" "}
            <Text strong>{selectedUserData?.firstName}</Text>
          </Text>
        ),
        name: "sendToEmployee",
        span: 24,
        onChange: handleCheckboxChange,
      },
      {
        type: "checkbox",
        label: (
          <Text>
            Send Evaluation to Reporting HR{" "}
            <Text strong></Text>
          </Text>
        ),
        name: "sendToHR",
        span: 24,
        onChange: handleCheckboxChange,
      },
      {
        type: "checkbox",
        label: (
          <Text>
            Send Evaluation form to Business Unit{" "}
            <Text strong>{selectedUserData?.businessUnit.name}</Text>
          </Text>
        ),
        name: "sendToBuisinessUnit",
        span: 24,
        onChange: handleCheckboxChange,
      },
    ],
    
    getColumns: () => [
      {
        title: "Employee Name",
        dataIndex: "firstName",
        key: "firstName",
        render: (_: string, record: any) => (
          <div>
            <div>{`${record.firstName} ${record.lastName || ""}`}</div>
            <div style={{ fontSize: "0.60rem", color: "gray" }}>{record.employeeId}</div>
          </div>
        ),
      },
      {
        title: "Job Title",
        dataIndex: ["role", "name"],
        key: "role",
        align: "center",
        render: (_: string, record: any) => record.role?.name || "N/A",
      },
      {
        title: "Department",
        dataIndex: ["department", "name"],
        key: "department",
        align: "center",
      },
      {
        title: "Location",
        dataIndex: ["location", "name"],
        key: "location",
        align: "center",
      },
      {
        title: "Date of Joining",
        dataIndex: "dateOfJoining",
        key: "dateOfJoining",
        align: "center",
        render: formatDate,
      },
      {
        title: "Probation End Date",
        dataIndex: "probationEndDate",
        key: "probationEndDate",
        align: "center",
        render: (date) => (
          <>
            <div>{formatDate(date)}</div>
            <div style={{ fontSize: "0.70rem", color: "gray" }}>{getDaysRemaining(date)}</div>
          </>
        ),
      },
      {
        title: "Extension",
        dataIndex: "extension",
        key: "extension",
        align: "center",
        render: (text: string) => text || "N/A",
      },
      {
        title: "Actions",
        key: "actions",
        align: "center",
        render: (_: any, record: any) => (
          <Button type="link" onClick={() => handleStartEvaluation(record._id, record)}>
            Start Evaluation
          </Button>
        ),
      },
    ],
  };

  return (
    <div>
      <HeadingSubHeading title="In Probation" subTitle="Probation Evaluation Progress" />
      <MasterComponent config={config} />
      <FormSetup
        open={open}
        config={{
          ...config,
          modalProps: {
            ...config.modalProps,
            footer: [
              <Button key="cancel" onClick={() => setOpen(false)}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={handleSubmitEvaluation} loading={loading}>
                Submit
              </Button>
            ]
          }
        }}
        onClose={() => setOpen(false)}
        isModal={true}
      />

    </div>
  );
};

export default InProbation;
